import angular from 'angular'
import routers from './routers.js'
import comprehensiveIncomeTaxCtrl from './comprehensiveIncomeTaxCtrl.js'

export default angular
    .module('declaration.personalIncomeTax.comprehensiveIncomeTax', []).config(['$stateProvider', ($stateProvider) => {
        Object.keys(routers).forEach((router) => {
            $stateProvider.state(routers[router].state, routers[router].config)
        })
    }])
    .controller('comprehensiveIncomeTaxCtrl', comprehensiveIncomeTaxCtrl)
    .name



// WEBPACK FOOTER //
// ./src/app/declaration/personalIncomeTax/comprehensiveIncomeTax/index.js